import { create } from "zustand"
import api from "../../../api/axios"
import { Image } from "antd"
import noimg from './../../../assets/img/noimg.jpg'

export const useFoods = create((set, get) => ({
    foods: [],
    columns: [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 70,
        },
        {
            title: 'Rasm',
            dataIndex: 'img',
            key: 'img',
            render: (img) => <Image src={img ? process.env.REACT_APP_URL + img : noimg} alt="food" width={100} height={100} style={{objectFit: 'cover', borderRadius: '20px', border: '1px solid #ccc'}} />,
            width: 140,
        },
        {
            title: 'Nomi',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Narxi',
            dataIndex: 'price',
            key: 'price',
        },
        {
            title: 'Tavsifi',
            dataIndex: 'note',
            key: 'note',
        }
    ],

    getFoods: async () => {
        const response = await api.get(`/foods`)
        const data = response.data.data
        set({ foods: data })
        return data
    },

    addFood: async (food) => {
        const response = await api.post(`/foods`, food)
        const data = response.data.data
        set({ foods: [data, ...get().foods] })
        return data
    },
    
    updateFood: async (id, food) => {
        const response = await api.put(`/foods/${id}`, food)
        const data = response.data.data
        set({ foods: get().foods.map(f => f.id === id ? data : f) })
        return data
    },
    
    deleteFood: async (id) => {
        const response = await api.delete(`/foods/${id.id}`)
        const data = response.data.data
        get().getFoods()
        return data
    },
    


}))